import React from "react";
import Translate from "src/ui/components/Translate/Translate";
import type { SignupSuccessPageProps } from "../../SignupSuccessPage";

const genericFinalSuccessPageProps: SignupSuccessPageProps = {
  title: (
    <>
      <Translate msg="funnel.success.title" />
    </>
  ),
  subtitle: <Translate msg="funnel.success.subtitle" />
};

export default genericFinalSuccessPageProps;
